import React from 'react';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { IForBankFormSubSections } from 'components/BusinessToolForm/Sections/forBankSections';

import { ProductAndServicesAdvantages } from './ProductAndServicesAdvantages';
import { ProductAndServicesDeliveryAndSupport } from './ProductAndServicesDeliveryAndSupport';
import { ProductAndServicesDescription } from './ProductAndServicesDescription';
import { ProductAndServicesRAndD } from './ProductAndServicesRAndD';

const SUB_SECTIONS: IForBankFormSubSections = {
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.DESCRIPTION]: ProductAndServicesDescription,
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.ADVANTAGES]: ProductAndServicesAdvantages,
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.R_AND_D]: ProductAndServicesRAndD,
  [BUSINESS_TOOL_SUB_SECTIONS.PRODUCTS_AND_SERVICES.DELIVERY_AND_SUPPORT]: ProductAndServicesDeliveryAndSupport,
};

export const ProductsAndServices: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
